import ACTIONS, { FETCH_STATUS } from "../constants";

export const getScopeAttempt = {
  pending: {
    type: ACTIONS.SCOPE.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.SCOPE.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.SCOPE.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const getScope = (state) => ({
  type: ACTIONS.SCOPE_CALL,
  payload: state,
});


export const getScopeDetailsAttempt = {
  pending: {
    type: ACTIONS.SCOPE_DETAILS.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.SCOPE_DETAILS.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.SCOPE_DETAILS.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const getScopeDetails = (state) => ({
  type: ACTIONS.SCOPE_DETAILS_CALL,
  payload: state,
});

export const createScopeAttempt = {
  pending: {
    type: ACTIONS.CREATE_SCOPE.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.CREATE_SCOPE.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.CREATE_SCOPE.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const createScopeRequest = (state) => ({
  type: ACTIONS.CREATE_SCOPE_CALL,
  payload: state,
});

export const updateScopeAttempt = {
  pending: {
    type: ACTIONS.UPDATE_SCOPE.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.UPDATE_SCOPE.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.UPDATE_SCOPE.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const updateScopeRequest = (state) => ({
  type: ACTIONS.UPDATE_SCOPE_CALL,
  payload: state,
});

export const deleteScopeAttempt = {
  pending: {
    type: ACTIONS.DELETE_SCOPE.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.DELETE_SCOPE.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.DELETE_SCOPE.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const duplicateScopeRequest = (state) => ({
  type: ACTIONS.DUPLICATE_SCOPE_CALL,
  payload: state,
});

export const duplicateScopeAttempt = {
  pending: {
    type: ACTIONS.DUPLICATE_SCOPE.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.DUPLICATE_SCOPE.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.DUPLICATE_SCOPE.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const duplicateTaskRequest = (state) => ({
  type: ACTIONS.DUPLICATE_TASK_CALL,
  payload: state,
});

export const duplicateTaskAttempt = {
  pending: {
    type: ACTIONS.DUPLICATE_TASK.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.DUPLICATE_TASK.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.DUPLICATE_TASK.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const deleteScopeRequest = (state) => ({
  type: ACTIONS.DELETE_SCOPE_CALL,
  payload: state,
});

export const updateScopeFlagAttempt = {
  pending: {
    type: ACTIONS.SCOPE_FLAG.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.SCOPE_FLAG.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.SCOPE_FLAG.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const updateScopeFlag = (state) => ({
  type: ACTIONS.SCOPE_FLAG_CALL,
  payload: state,
});

// get tasks
export const getTaskAttempt = {
  pending: {
    type: ACTIONS.TASK.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.TASK.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.TASK.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const getTasks = (state) => ({
  type: ACTIONS.TASK_CALL,
  payload: state,
});

//create task
export const createTaskAttempt = {
  pending: {
    type: ACTIONS.CREATE_TASK.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.CREATE_TASK.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.CREATE_TASK.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const createTask = (state) => ({
  type: ACTIONS.CREATE_TASK_CALL,
  payload: state,
});

export const updateTaskAttempt = {
  pending: {
    type: ACTIONS.UPDATE_TASK.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.UPDATE_TASK.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.UPDATE_TASK.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const updateTask = (state) => ({
  type: ACTIONS.UPDATE_TASK_CALL,
  payload: state,
});

export const updateTaskStatusAttempt = {
  pending: {
    type: ACTIONS.UPDATE_TASK_STATUS.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.UPDATE_TASK_STATUS.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.UPDATE_TASK_STATUS.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const updateTaskStatus = (state) => ({
  type: ACTIONS.UPDATE_TASK_STATUS_CALL,
  payload: state,
});

// delete Task

export const deleteTaskAttempt = {
  pending: {
    type: ACTIONS.DELETE_TASK.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.DELETE_TASK.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.DELETE_TASK.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const deleteTask = (state) => ({
  type: ACTIONS.DELETE_TASK_CALL,
  payload: state,
});

export const updateTaskFlagAttempt = {
  pending: {
    type: ACTIONS.TASK_FLAG.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.TASK_FLAG.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.TASK_FLAG.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const updateTaskFlag = (state) => ({
  type: ACTIONS.TASK_FLAG_CALL,
  payload: state,
});

export const sortScopeItemsRequestAttempt = {
  pending: {
    type: ACTIONS.SORT_SCOPEITEMS.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.SORT_SCOPEITEMS.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.SORT_SCOPEITEMS.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const sortScopeItemsRequest = (state) => ({
  type: ACTIONS.SORT_SCOPEITEMS_CALL,
  payload: state,
});

export const sortTasksRequestAttempt = {
  pending: {
    type: ACTIONS.SORT_TASKS.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.SORT_TASKS.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.SORT_TASKS.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const sortTasksRequest = (state) => ({
  type: ACTIONS.SORT_TASKS_CALL,
  payload: state,
});

export const resourcesShifts = {
  pending: {
    type: ACTIONS.RESOURCE_SHIFTS.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.RESOURCE_SHIFTS.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.RESOURCE_SHIFTS.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const resourcesShiftsRequest = (state) => ({
  type: ACTIONS.RESOURCE_SHIFTS_CALL,
  payload: state,
});

export const resourcesMonitor = {
  pending: {
    type: ACTIONS.RESOURCE_MONITOR.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.RESOURCE_MONITOR.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.RESOURCE_MONITOR.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const resourcesMonitorRequest = (state) => ({
  type: ACTIONS.RESOURCE_MONITOR_CALL,
  payload: state,
});

export const capacityRequest = (state) => ({
  type: ACTIONS.RESOURCE_CAPACITY,
  data: state,
});
